import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";

import Close from "@material-ui/icons/Close";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import images from "../../assets/img/images";
export class MessageStatus {
  static ERROR = new MessageStatus("error");
  static WARNING = new MessageStatus("warning");
  static INFO = new MessageStatus("info");
  static SUCCESS = new MessageStatus("success");
  static NAKED = new MessageStatus("naked");

  constructor(name) {
      this.name = name;
  }
}

const styles = {
  messageDialog: {
    width: "330px",
    minHeight: "170px",
    padding: "24px",
    display: "flex",

    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  messageDialogNav: {
    width: "100%",
    height: "24px",
    display: "grid",
    gridTemplateColumns: "1fr 24px",
    placeItems: "center",
    marginBottom: "16px",
  },

  interactPanel: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",

  },
  messageDialogTitle: {
    display: "flex",
    alignItems: "center",
    // fontSize: "14px",

    "& div": {
      marginLeft: "8px",
    }
  },

  messageText: {
    textAlign: "Center"
  },

  closeButton: {
    justifySelf: "end",
    alignSelf: "center",
    width: "24px",
    height: "24px",

    "&:hover": {
      backgroundColor: "#f2f9fa",
      borderRadius: "2px",
      cursor: "pointer",
    }
  },

  buttonContainer: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "space-between",
  },
};

const MessageDialog = (props) => {
  const { classes, open, onClose, title, message, status,isEvent=false } = props;

  const handleClose = () => {
    onClose();
  }

  const handleOk = () => {
    onClose(true);
  }

  const statusIcon = () => {
    switch (status) {
      case MessageStatus.ERROR:
        return <><img className={classes.center_check} src={images.errorIcon} alt="errorIcon" /><br /></>;
      case MessageStatus.WARNING:
        return <><img className={classes.center_check} src={images.warningIcon} alt="errorIcon" /><br /></>;
      case MessageStatus.INFO:
        return <><img className={classes.center_check} src={images.infoIcon} alt="errorIcon" /><br /></>;
      case MessageStatus.SUCCESS:
        return <><img className={classes.center_check} src={images.successIcon} alt="errorIcon" /><br /></>;
      case MessageStatus.NAKED:
      default:
        return;
    }
  }

  return (
    <Dialog
      open={open}
    >
      <div className={classes.messageDialog}>
        <div className={classes.messageDialogNav}>
          <div className={classes.messageDialogTitle}>
            <div>{title ? title.toUpperCase() : ""}</div>
          </div>
          <div className={classes.closeButton}>
            <Close onClick={() => handleClose()} />
          </div>
        </div>

        <div className={classes.interactPanel}>
          {!isEvent && statusIcon()}
          <span className={classes.messageText}>{message}</span>
        </div>
        <div className={classes.buttonContainer}>
          <Button onClick={() => handleOk()}><span style={{ fontWeight: "bold", color: "#0096a7", position: "relative" }}>{I18n.get(isEvent ? "events_yes": "site_ok").toUpperCase()}</span></Button>
          {isEvent &&<Button onClick={() => handleClose()}><span style={{ fontWeight: "bold", color: "#0096a7", position: "relative" }}>{I18n.get("events_no").toUpperCase()}</span></Button>}
        </div>
      </div>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"])
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(MessageDialog))
);
